export function addErrorMsg({ field, msg }) {
  const [input] = document.getElementsByName(field)
  const inputWrap = input.parentElement

  const errorMsg = document.createElement('p')
  errorMsg.innerText = msg
  errorMsg.classList.add('custom-budget__error')
  const existError = inputWrap.querySelectorAll('.custom-budget__error')
  if (existError.length !== 0) return
  inputWrap.appendChild(errorMsg)
}
